<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="pa-3">
          <v-layout row wrap>
            <v-flex md3 class="pl-1">
              <!-- <v-menu
                v-model="invoiceDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="reportFilters.date"
                    label="Receive date"
                    readonly
                    outline
                    required
                    :rules="requiredRules"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="reportFilters.date"
                  @input="invoiceDateMenu = false"
                ></v-date-picker>
              </v-menu> -->
            </v-flex>
            <v-flex md3 class="pl-1">
              <!-- <v-menu
                v-model="invoiceDateMenu2"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="reportFilters.date2"
                    label="Date To"
                    readonly
                    outline
                    required
                    :rules="requiredRules"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :min="reportFilters.date"
                  v-model="reportFilters.date2"
                  @input="invoiceDateMenu2 = false"
                ></v-date-picker>
              </v-menu> -->
            </v-flex>
            <v-flex md6 class="text-xs-right">
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    color="primary"
                    fab
                    small
                    dark
                    @click="isSearchModal = true"
                  >
                    <v-icon>search</v-icon>
                  </v-btn>
                </template>
                <span>Advance Search</span>
              </v-tooltip>
            </v-flex>
          </v-layout>

          <ListLoader v-if="isLoadingContent"></ListLoader>
          <div class="simple-table-container" id="invoice-dues-report" v-else>
            <div class="hidden-screen-only report-header text-center">
              <div class="head">
                {{ settings && settings.company_name }}
              </div>
              <div class="address">
                {{ settings && settings.company_address }}
              </div>
              <hr />
              <br />
              <div class="title">
                Invoice dues up to today -
              {{ $moment().format("DD MMMM, YYYY") }}
              </div>
            </div>
            <table class="table table-bordered">
              <tr>
                <tr>
                <th>Invoice No.</th>
                <th>Date</th>
                <th>Company</th>
                <th>Coordinator</th>
                <th>Client</th>
                <th>Project</th>
                <th>Amount</th>
                <th>Due Amount</th>
              </tr>
              </tr>
              <tr v-for="item in reportData" :key="item.id">
                <td>{{ item.invoice_number }}</td>
                <td>{{ item.invoice_date }}</td>
                <td>{{ item.companies___name }}</td>
                <td>{{ item.coordinators___name }}</td>
                <td>{{ item.clients___name }}</td>
                <td>{{ item.client_project_name }}</td>
                <td>{{ item.amount }}</td>
                <td>{{ item.amount - item.receive_amount }}</td>
              </tr>
              <tr>
                <td colspan="6"></td>
                <td><strong>{{ amountSum }}</strong></td>
                <td><strong>{{ dueSum }}</strong></td>
              </tr>
              <tr>
                <td colspan="9" class="report-sum text-center">
                  Total Dues &nbsp;&nbsp; {{ mA(dueSum) }}
                </td>
              </tr>
            </table>
          </div>
          <v-card-actions>
            <v-btn flat @click="print()">Print</v-btn>
            <!-- <v-btn flat >Explore</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="isSearchModal" scrollable persistent max-width="500px">
      <AdvanceSearch
        :rfilters="reportFilters"
        :hide="['date', 'date2', 'account_head']"
        @cancelled="isSearchModal = false"
      />
    </v-dialog>
  </div>
</template>



<script>
import { ContentLoader, ListLoader } from "vue-content-loader";
import AdvanceSearch from "../SearchModal";
import { columnSum } from "../../mdsir/MdsirUtils";

export default {
  components: {
    ContentLoader,
    ListLoader,
    AdvanceSearch,
  },
  data: () => ({
    isSearchModal: false,
    isLoadingContent: false,
    invoiceDateMenu: false,
    invoiceDateMenu2: false,
    reportFilters: {
      // date: new Date().toISOString().substr(0, 10),
      // date2: new Date().toISOString().substr(0, 10),
    },
    reportData: [],
  }),

  computed: {
    amountSum() {
      return columnSum(this.reportData, 'amount');
    },
    receiveSum() {
      return columnSum(this.reportData, 'receive_amount');
    },
    dueSum() {
      return this.amountSum - this.receiveSum;
    },
  },

  watch: {
    reportFilters: {
      handler: function (val, oldVal) {
        this.getDataFromApi();
      },
      deep: true,
    },
  },

  created() {},

  mounted() {
    this.getDataFromApi();
  },

  methods: {
    getDataFromApi() {
      this.isLoadingContent = true;
      this.get("/invoice_dues_report", this.reportFilters).then((response) => {
        this.reportData = response.data;
        this.isLoadingContent = false;
      });
    },
    print() {
      this.$htmlToPaper("invoice-dues-report");
    },
  },

  beforeDestroy() {},
};
</script>

<style scoped>
.simple-table-container {
  overflow: auto;
}
.table {
  border-collapse: collapse;
  width: 100%;
}
.table th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #bebebe;
}

.table td,
.table th {
  border: 1px solid #ddd;
  padding: 8px;
}

.table td.report-sum {
  padding: 6px;
  text-align: center;
  background-color: #0f0f0f0e;
  font-size: 20px;
  font-weight: bold;
}
</style>